import styled from "styled-components";

export const StyledNav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: var(--fw-bold);
  background: ${({ theme }) => theme.colors.background};

  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
    position: relative;

    &.active::before,
    &.active::after {
      display: block;
      z-index: -1;
      content: "";
      position: absolute;
      width: 10px;
      height: 2px;
      border-radius: 1px;
      background-color: ${({ theme }) => theme.colors.buttonSecondary};
      top: 50%;
      transform: translateY(-50%);
    }

    &.active::before {
      left: -15px;
    }

    &.active::after {
      right: -15px;
    }
  }

  @media ${({ theme }) => theme.mq.sm} {
    font-size: ${({ theme }) => theme.fonts.sizes.base};
    display: block;
    grid-column: 1/-1;
    grid-row: 2/3;
    padding: 46px 0;
    height: 100%;
    z-index: 2000;

    @media (max-height: 486px) {
      overflow: auto;
    }
  }
`;

export const NavList = styled.ul`
  display: flex;
  list-style-type: none;
  padding: 0;
  margin: 0 16px;

  @media ${({ theme }) => theme.mq.sm} {
    flex-direction: column;
    align-items: center;
    margin: 0;
    margin-bottom: 48px;
  }
`;
